import { useFormik } from "formik";
import { validationSchema } from "../validations/validationsPartners";

export const useFormRCSPartners = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      period: {
        dateFrom: "",
        dateTo: "",
      },
      partner: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const dataToSubmit = {
        from: values?.period?.dateFrom,
        to: values?.period.dateTo,
        uid_partner: values?.partner,
      };

      onSubmit(dataToSubmit);
    },
  });
};
